import React from 'react';
import { productShortName } from '../data/offer';
export function Footer() {
  return <footer className="bg-navy-950 text-steel-light" data-id="element-72" data-mp="3gezdb400vr15">
      <div className="h-px w-full bg-copper" aria-hidden="true" data-id="element-73" data-mp="3ggu1cr6lbz9g" />
      <div className="mx-auto max-w-3xl px-4 py-8 text-center" data-id="element-74" data-mp="32onkt3zizq9h">
        <p className="text-xs" data-id="element-75" data-mp="36pft9v0kpr4p">© 2026 {productShortName} — All rights reserved.</p>
      </div>
    </footer>;
}